import { createSlice } from "@reduxjs/toolkit";
import { showTimesheet, showTimesheetSummaryData, showTimesheetManager, showTimesheetApproval } from "../actions";

const initialState = {
  timesheet: [],
};

const timesheetSlice = createSlice({
  name: "timesheet",
  initialState,
  reducers: {},
  extraReducers: {
    [showTimesheet.fulfilled]: (state, action) => {
      state.timesheet = action.payload || [];
    },
    [showTimesheetSummaryData.fulfilled]: (state, action) => {
      state.timesheet = action.payload || [];
    },
    [showTimesheetManager.fulfilled]: (state, action) => {
      state.timesheet = action.payload || [];
    },
    [showTimesheetApproval.fulfilled]: (state, action) => {
      state.timesheet = action.payload || [];
    },
  },
});

export const responseTimesheet = (state) => state.timesheet;

export default timesheetSlice.reducer;
